/**
 * Section
 *
 * @todo IW: Events requires a seperate way to handle ID as it has no header anymore, think about this later
 * @todo IW: Need a way to add classNames to the Wrapper - really should be a new component - for now made simple
 */
import React, { ReactNode } from 'react'

import { Header } from '../Header/Header'
import { onAnchorTriggerKey } from '../../utils'

export type SectionHeaderProps = {
  number: string
  title: string
}

export type SectionProps = {
  children: ReactNode
  className?: string
  headerClassName?: string
  clearFix?: string
  hasWrapper?: boolean
  hideNumber?: boolean
  hideTitle?: boolean
  header?: SectionHeaderProps
  headerIconClasses?: string
  headerIconTooltip?: string
  minHeight?: string
  headerIconOnClick?: () => void
}

export const Section = ({
  header,
  children,
  className,
  headerClassName = 'frw-heading--3 frw-content',
  clearFix = '',
  hasWrapper,
  hideNumber = false,
  hideTitle = false,
  headerIconClasses,
  headerIconTooltip,
  headerIconOnClick,
  minHeight
}: SectionProps) => {
  const id = header ? header.title : ''
  const titleId = id.replace(/\s+/g, '-').toLowerCase()
  const customMinHeight = minHeight || '330px'

  const sectionChildren = (
    <>
      {header ? (
        <div className="frw-wrapper--1">
          <div>
            <Header
              level={2}
              className={`${headerClassName}`}
              iconClasses={headerIconClasses}
              iconOnClick={headerIconOnClick}
            >
              {!hideNumber ? (
                <span className="frw-heading--no">{header.number}</span>
              ) : null}
              {!hideTitle ? header.title : null}
              {headerIconClasses ? (
                <i
                  className={`frw-cursor-pointer frw-margin-left-tiny ${headerIconClasses}`}
                  onClick={headerIconOnClick || (() => {})}
                  onKeyDown={onAnchorTriggerKey(headerIconOnClick)}
                  title={headerIconTooltip || ''}
                  tabIndex={0}
                  role="link"
                />
              ) : (
                ''
              )}
            </Header>{' '}
          </div>
        </div>
      ) : null}
      {children}
    </>
  )

  return (
    <section
      className={className ? `${className} frw-section` : 'frw-section'}
      id={titleId}
      style={{
        minHeight: customMinHeight
      }}
    >
      {(hasWrapper && (
        <div className={`frw-wrapper--1 ${clearFix}`}>{sectionChildren}</div>
      )) ||
        sectionChildren}
    </section>
  )
}

export default Section
